import { useNavigate } from 'react-router-dom';

import { CampaignPeerSearchModal } from '../../../components';

export const ParticipantsPage = () => {
  const navigate = useNavigate();
  return (
    <CampaignPeerSearchModal opened={true} type="participants" onClose={() => navigate('..')} />
  );
};
